import React from "react";
import { Empty } from "antd";

import { CompassWhiteButton } from "../../components/buttons/styledComponents";
import { ElementContainer } from "../../components/containers/styledComponents";
import { CompassParagraph } from "../../components/common/styledComponents";
import { compassBordeaux, greyText } from "../../styles";

export const ChartEmptyState = ({
  variant,
  entityName,
  onRetry,
}: ChartEmptyStateProps): JSX.Element => {
  if (variant === "error") {
    return (
      <ElementContainer
        ai="center"
        jc="center"
        h="100%"
        w="100%"
        flexDirection="column"
        p={16}
      >
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <CompassParagraph color={compassBordeaux} fontSize={13} mr={0}>
              {`Failed to load ${entityName}.`}
            </CompassParagraph>
          }
        />
        {onRetry && (
          <ElementContainer mt={12} jc="center">
            <CompassWhiteButton size="s" onClick={onRetry}>
              Retry
            </CompassWhiteButton>
          </ElementContainer>
        )}
      </ElementContainer>
    );
  }

  return (
    <ElementContainer
      ai="center"
      jc="center"
      h="100%"
      w="100%"
      flexDirection="column"
      p={16}
    >
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <CompassParagraph color={greyText} fontSize={13} mr={0}>
            {`No ${entityName} match the current filters.`}
          </CompassParagraph>
        }
      />
    </ElementContainer>
  );
};

type ChartEmptyStateProps = {
  variant: "empty" | "error";
  entityName: string;
  onRetry?: () => void;
};
